<script>
	import { fade } from 'svelte/transition';
	import { onMount } from 'svelte';
	let ready = false;
	onMount(() => { ready = true; });
</script>

<main>
	{#if ready}
	  	<h1 in:fade="{{ duration: 2000 }}">cirri.cloud</h1>
    {/if}
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 240px;
		margin: 0 auto;
	}

	h1 {
		color: #003ecc;
		text-transform: lowercase;
		font-family: 'Comfortaa', cursive;
		font-size: 5em;
		font-weight: 400;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
